import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    noBackground?: boolean;
  }>()
  .create(({ theme, noBackground }) => ({
    loadingIndicator: {
      alignItems: 'center',
      backdropFilter: 'blur(2px)',
      backgroundColor: noBackground ? 'transparent' : 'rgba(0,0,0,.1)',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      zIndex: theme.zIndex.modal
    }
  }));

export default useStyles;
